import { SvgSettings } from "@itwin/itwinui-icons-react"
import { IconButton, Tooltip } from "@itwin/itwinui-react"
import { useAppDispatch, useAppSelector } from "store"
import { sandboxActionInvoked } from "store/features";


export const SandboxSettingsButton = () => {
  const sandbox = useAppSelector((state) => state.activeSandbox.metadata);
  const dispatch = useAppDispatch();

  if (!sandbox)
    return null;

  const onClick = () => {
    dispatch(sandboxActionInvoked({
      type: "sandbox-settings",
      args: {
        userId: sandbox.userId,
        sandboxId: sandbox.id,
      }
    }));
  }

  return (
    <Tooltip content="Sandbox Settings" placement="bottom" delay={500}>
      <IconButton styleType="borderless" onClick={onClick} data-testid="atp-settings-btn"><SvgSettings /></IconButton>
    </Tooltip>
  )
}